export const FETCH_SCOPEACTIVITY_REQUEST = 'FETCH_SCOPEACTIVITY_REQUEST'
export const FETCH_SCOPEACTIVITY_SUCCES = 'FETCH_SCOPEACTIVITY_SUCCES'
export const FETCH_SCOPEACTIVITY_ERROR = 'FETCH_SCOPEACTIVITY_ERROR'



// WEBPACK FOOTER //
// ./src/constants/ScopeActivity.js